import React from 'react';

const ArticleCard = ({ article }) => {
  // Format the date nicely
  const formatDate = (dateString) => {
    if (!dateString) return 'Date not available';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'Date not available';
    }
  };

  // Truncate text to a reasonable length
  const truncateText = (text, maxLength = 150) => {
    if (!text) return 'No content available';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Get sentiment color
  const getSentimentColor = (sentiment) => {
    if (!sentiment) return 'text-gray-500';
    
    const lowerSentiment = sentiment.toLowerCase();
    if (lowerSentiment.includes('positive') || lowerSentiment.includes('bullish')) {
      return 'text-green-600';
    } else if (lowerSentiment.includes('negative') || lowerSentiment.includes('bearish')) {
      return 'text-red-600';
    } else if (lowerSentiment.includes('neutral')) {
      return 'text-blue-600';
    }
    return 'text-gray-500';
  };

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300 overflow-hidden">
      {/* Article Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight hover:text-blue-600 transition-colors">
              {article.title || 'No Title Available'}
            </h3>
            
            {/* Source and Date */}
            <div className="flex items-center space-x-4 text-sm text-gray-600 mb-3">
              {article.source && (
                <span className="font-medium text-blue-600">
                  {article.source}
                </span>
              )}
              <span className="text-gray-500">
                {formatDate(article.date)}
              </span>
            </div>
          </div>
          
          {/* Sentiment Badge */}
          {article.sentiment && (
            <div className={`px-3 py-1 rounded-full text-xs font-medium bg-gray-100 ${getSentimentColor(article.sentiment)}`}>
              {article.sentiment}
            </div>
          )}
        </div>
        
        {/* Article Content */}
        <p className="text-gray-700 leading-relaxed mb-4">
          {truncateText(article.text)}
        </p>
      </div>
      
      {/* Article Footer */}
      <div className="px-6 py-4 bg-gray-50">
        <div className="flex items-center justify-between">
          {/* Stock Symbols */}
          <div className="flex flex-wrap gap-2">
            {article.symbols && article.symbols.length > 0 ? (
              article.symbols.map((symbol, index) => (
                <span
                  key={index}
                  className="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-md"
                >
                  {symbol}
                </span>
              ))
            ) : (
              <span className="text-gray-500 text-sm">No symbols mentioned</span>
            )}
          </div>
          
          {/* Read More Link */}
          {article.link && (
            <a
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200"
            >
              Read More
              <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          )}
        </div>
        
        {/* Tags - Hidden as per requirements */}
        {/* {article.tags && article.tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {article.tags.map((tag, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-gray-200 text-gray-700 text-xs rounded-md"
              >
                #{tag}
              </span>
            ))}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ArticleCard;
